// home.component.ts
import { Component, OnInit } from '@angular/core';
import { AdminAuthService, AdminUserInfo } from '../service/admin-auth.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  imports: [RouterLink]
})
export class HomeComponent implements OnInit {
  isAdminLoggedIn: boolean = false;
  adminUserInfo: AdminUserInfo = { userName: null, email: null, tenantId: null };
  admin_logged_in = false;

  constructor(private authService: AdminAuthService) { }
  ngOnInit() {
    localStorage.setItem(`is_admin`, "true");
    this.authService.adminUserInfo$.subscribe((userInfo) => {
      this.adminUserInfo = userInfo;
      this.admin_logged_in = !!userInfo.userName;
      console.log(`[HomeComponent] admin_logged_in =`, this.admin_logged_in, 'adminUserInfo =', this.adminUserInfo);
    });
  }
}
